import { render, staticRenderFns } from "./KitMetricGaugeChart.vue?vue&type=template&id=fedc8b80"
import script from "./KitMetricGaugeChart.vue?vue&type=script&lang=ts"
export * from "./KitMetricGaugeChart.vue?vue&type=script&lang=ts"
import style0 from "./KitMetricGaugeChart.vue?vue&type=style&index=0&id=fedc8b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports